import * as React from "react";
import { tl } from "../../../../utils";
import { Box, Checkbox, Grid, Collapse, Typography } from "@material-ui/core";
import { themeVariables, MUITooltip, MUICourseIcon } from "..";
import * as styles from "./styles.scss";
import { MUIShopBenefit } from "./shopBenefit";

import {
  ICourse,
  IBenefitPlan,
  IIdBenefit,
} from "../../Courses/GroupSettings/types";

interface IProps {
  courses: ICourse[];
  plans?: IBenefitPlan[];
  coursesChecked: IIdBenefit[];
  getCurrency?: (code: string) => string;
  setCoursesChecked: (coursesChecked: IIdBenefit[]) => void;
  isShop?: boolean;
  noTitle?: boolean;
}

export const MUICoursesChoise = ({
  courses,
  plans,
  coursesChecked,
  setCoursesChecked,
  isShop,
  getCurrency,
  noTitle,
}: IProps) => {
  const onBenefitChange = (
    courseBenefitChecked: IIdBenefit,
    benefitValue: number
  ) => {
    courseBenefitChecked.benefitId = benefitValue;
    changeCoursesChecked(courseBenefitChecked, true);
  };

  const changeCoursesChecked = (value: IIdBenefit, changeBenefit?: boolean) => {
    const coursesTemp = coursesChecked.filter(
      (item: IIdBenefit) => item.id !== value.id
    );
    if (coursesTemp.length !== coursesChecked.length) {
      if (changeBenefit) setCoursesChecked([...coursesTemp, value]);
      else setCoursesChecked([...coursesTemp]);
    } else setCoursesChecked([...coursesChecked, value]);
  };

  return (
    <>
      {courses.map((course: ICourse) => {
        const courseBenefitChecked = coursesChecked.find(
          (item: IIdBenefit) => item.id === course.id
        );
        const coursePlan = plans
          ? plans.find((item: IBenefitPlan) => item.courseId === course.id)
          : null;
        return (
          <Grid container key={`course-key-${course.id}`}>
            <Grid item xs={12}>
              <Box
                clone
                bgcolor={themeVariables.palette.grey.A400}
                borderTop={themeVariables.border}
              >
                <Grid
                  item
                  xs={12}
                  className={
                    !courseBenefitChecked ? `react-hideBgOnHover` : null
                  }
                >
                  <Grid container alignItems="center" wrap="nowrap">
                    <Box clone borderRight={themeVariables.border}>
                      <Grid item className={styles.courseChecked}>
                        <Checkbox
                          color="primary"
                          size="small"
                          data-testid="checkBox"
                          checked={!!courseBenefitChecked}
                          onChange={(event: any) =>
                            changeCoursesChecked({
                              id: course.id,
                              benefitId:
                                coursePlan && coursePlan.benefits
                                  ? coursePlan.benefits[0].id
                                  : 0,
                            })
                          }
                        />
                      </Grid>
                    </Box>
                    <Box clone pl={1}>
                      <Grid
                        item
                        xs
                        onClick={() =>
                          changeCoursesChecked({
                            id: course.id,
                            benefitId:
                              coursePlan && coursePlan.benefits
                                ? coursePlan.benefits[0].id
                                : 0,
                          })
                        }
                      >
                        <Box pl={1}>
                          <Grid
                            container
                            alignItems="center"
                            spacing={1}
                            wrap="nowrap"
                          >
                            <Grid item>
                              <MUICourseIcon
                                icon={
                                  course.icon ? `/media/80/${window.btoa(course.icon)}` : ""
                                }
                              />
                            </Grid>
                            <Grid item xs>
                              <MUITooltip
                                placement="top"
                                title={noTitle ? "" : course.name}
                              >
                                <Typography variant="subtitle2">
                                  <Box className={styles.name}>
                                    <b>{course.name}</b>
                                  </Box>
                                </Typography>
                              </MUITooltip>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            {isShop ? (
              <Grid item xs={12}>
                <Box
                  clone
                  bgcolor={themeVariables.palette.grey.A400}
                  borderTop={
                    !!courseBenefitChecked && !!coursePlan
                      ? themeVariables.border
                      : null
                  }
                >
                  <Collapse in={!!courseBenefitChecked}>
                    {coursePlan?.benefits ? (
                      <Box pt={2} pr={2.5}>
                        <MUIShopBenefit
                          benefits={coursePlan?.benefits}
                          courseBenefit={courseBenefitChecked}
                          onBenefitChange={onBenefitChange.bind(
                            this,
                            courseBenefitChecked
                          )}
                          getCurrency={getCurrency}
                        />
                      </Box>
                    ) : (
                      <Box
                        py={2}
                        px={2.5}
                        textAlign="center"
                        borderTop={themeVariables.border}
                      >
                        {tl("Тариф не настроен")}
                      </Box>
                    )}
                  </Collapse>
                </Box>
              </Grid>
            ) : null}
          </Grid>
        );
      })}
    </>
  );
};
